<template>
  <p>
    {{ $t('dialogs.techWork') }}
  </p>
  <p-button
    class="btn p-button-primary"
    :label="$t('common.gotIt')"
    @click="close"
  />
</template>

<script setup lang="ts">
import { inject } from 'vue';
const dialogRef = inject('dialogRef');

function close() {
  dialogRef.value.close();
}
</script>

<style scoped lang="scss">
.btn {
  width: 100%;
  margin-top: 10px;
}

.step {
  ::v-deep(.p-blockui) {
    opacity: 0;
  }
}
.p-dialog-content {
  p {
    margin-top: 0;
    line-height: 1.4;
  }
}
</style>
